import React from "react";
import preloader from './../../assets/img/preloader.svg'

const Preloader = (props) => {

  return (
    <div style={{ width: '100px' }}>
      <img src={preloader} alt='preloader' />
    </div>
  )
}

export default Preloader;